import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDJDE0qa6lDrBsthDQHgXRpWnkRI1mHGx8",
  authDomain: "sumaarohcrm.firebaseapp.com",
  projectId: "sumaarohcrm",
  storageBucket: "sumaarohcrm.firebasestorage.app",
  messagingSenderId: "1026599570857",
  appId: "1:1026599570857:web:68b79043515064c6cec8b8",
  measurementId: "G-8K0TXHWPJM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
